import React from "react";
import { Radio, Switch, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
const languageOptions = [
  { label: "English", value: "en" },
  { label: "French", value: "fr" },
];

export default function ConfigSettings({
  locationId,
  settings,
  onChange,
  isRideChallenge,
}) {
  const { t } = useTranslation();
  return (
    <div>
      {!isRideChallenge && !locationId && (
        <>
          <Title mb="sm" order={4}>
            {t("mixer:microsite_settings:ask_for_preferred_location")}
          </Title>
          <Switch
            disabled={locationId ? true : false}
            checked={settings.preferred_location}
            label={
              settings.preferred_location ? t("common:on") : t("common:off")
            }
            onChange={() =>
              onChange({
                ...settings,
                preferred_location: !settings.preferred_location,
              })
            }
          />
        </>
      )}
      {/* <Title order={4} mt="lg">
        Ask for Geolocation
      </Title>
      <Switch
        disabled={settings.location_locked}
        checked={settings.geolocation_prompt}
        label={settings.geolocation_prompt ? "On" : "Off"}
        onChange={() =>
          onChange({
            ...settings,
            geolocation_prompt: !settings.geolocation_prompt,
          })
        }
      /> */}
      <Title order={4} mt="lg" mb="sm">
        {t("mixer:microsite_settings:lock_to_location")}
      </Title>
      <Switch
        checked={settings.location_locked}
        label={settings.location_locked ? t("common:on") : t("common:off")}
        onChange={() =>
          onChange({
            ...settings,
            geolocation_prompt:
              settings.geolocation_prompt === false
                ? true
                : settings.geolocation_prompt,
            location_locked: !settings.location_locked,
          })
        }
      />
      {true && (
        <>
          <Title mt="lg" mb="sm" order={4}>
            Language
          </Title>
          <Radio.Group
            value={settings.language}
            name="language"
            onChange={(lang) =>
              onChange({
                ...settings,
                language: lang,
              })
            }
          >
            {languageOptions.map((m, i) => (
              <Radio mb="xs" label={m.label} value={m.value} key={i} />
            ))}
          </Radio.Group>
        </>
      )}
    </div>
  );
}
